import React, { useState } from "react";
import axios from "axios";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Storia } from "@/components/Storia";
import { MenuSection } from "@/components/MenuSection";
import { Momenti } from "@/components/Momenti";
import { Recensioni } from "@/components/Recensioni";
import { Galleria } from "@/components/Galleria";
import { Contatti } from "@/components/Contatti";
import { Footer } from "@/components/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen bg-espresso text-cream flex items-center justify-center p-8 text-center">
          <p className="font-serif text-2xl">
            Si è verificato un errore. Ricarica la pagina.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  const [user, setUser] = useState(null);

  React.useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  React.useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const hash = window.location.hash;
    if (hash.includes("session_id=")) {
      const session_id = hash.split("session_id=")[1]?.split("&")[0];
      if (!session_id) return;
      axios
        .post(`${API}/auth/session`, { session_id }, { withCredentials: true })
        .then((res) => setUser(res.data))
        .catch(() => setUser(null))
        .finally(() => {
          window.history.replaceState(
            null,
            "",
            window.location.pathname + window.location.search
          );
        });
    } else {
      axios
        .get(`${API}/auth/me`, { withCredentials: true })
        .then((res) => setUser(res.data))
        .catch(() => setUser(null));
    }
  }, []);

  const handleLogout = () => {
    axios
      .post(`${API}/auth/logout`, {}, { withCredentials: true })
      .finally(() => setUser(null));
  };

  return (
    <ErrorBoundary>
      <div className="bg-espresso text-cream font-sans antialiased overflow-x-clip">
        <div className="grain" aria-hidden="true" />
        <Header user={user} onLogout={handleLogout} />
        <main>
          <Hero />
          <Marquee />
          <Storia />
          <MenuSection />
          <Momenti />
          <Recensioni />
          <Galleria />
          <Contatti />
        </main>
        <Footer />
      </div>
    </ErrorBoundary>
  );
}

export default App;
